import { AxiosResponse, AxiosError } from 'axios';
import { axios } from 'config/axios';
import { getId } from 'utils';

export type ArchiveCompanyResponse = { id: number; active: boolean };
export const archiveCompany = async (
  id: string,
  archive: boolean,
): Promise<AxiosResponse<ArchiveCompanyResponse>> =>
  axios
    .patch(
      `/companies/${getId(id)}/archive`,
      { archive: archive },
      {
        headers: {
          'content-type': 'application/merge-patch+json',
        },
      },
    )
    .then((response: AxiosResponse) => response.data)
    .catch((error: AxiosError) => Promise.reject(error.response));
